import { render, staticRenderFns } from "./addClean.vue?vue&type=template&id=628cd6ba&scoped=true&"
import script from "./addClean.vue?vue&type=script&lang=js&"
export * from "./addClean.vue?vue&type=script&lang=js&"
import style0 from "./addClean.vue?vue&type=style&index=0&id=628cd6ba&lang=less&scoped=true&"
import style1 from "./addClean.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628cd6ba",
  null
  
)

export default component.exports